<template>
  <div class="wrapper-section-cta-sidebar">
    <div class="section-1">&nbsp;</div>
    <div class="section-2">
      <div class="wrapper-cta">
        <h3 class="subtitle-sidebar">{{
          $t(`${base}.title`, { name: country.name })
        }}</h3>

        <a
          :href="whatsappLink"
          target="_blank"
          class="el-button el-button--success el-button--medium"
        >
          <i class="fab fa-whatsapp" /> {{ $t(`${base}.label`) }}
        </a>
      </div>
    </div>
    <div class="section-3">&nbsp;</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadSearchCtaSidebar',
  data() {
    return {
      base: 'search.country.cta_sidebar',
      contactInfo: { customer_service: { whatsapp: [''] } },
    }
  },
  computed: {
    ...mapState('settings', ['locale']),
    ...mapState('country', {
      country: (state) => ({
        name: state.header.name,
      }),
    }),
    whatsappLink() {
      const phone = this.contactInfo.customer_service.whatsapp[0]
      const text = this.$t(`${this.base}.whatsapp_message`, {
        name: this.country.name,
      })

      return this.isMobile
        ? `whatsapp://send?phone=${phone.replace(/ /g, '')}&text=${text}`
        : `https://wa.me/${phone.replace(/ |\+/g, '')}?text=${text}`
    },
  },
  watch: {
    locale: {
      immediate: true,
      handler(value) {
        this.contactInfo = require(`@/db/contact/${value.toLowerCase()}`).default
      },
    },
  },
}
</script>

<style lang="scss">
@mixin cta-sidebar-mobile() {
  border-radius: 10px 10px 0 0;

  .section-1,
  .section-3 {
    display: none;
  }

  .subtitle-sidebar {
    margin: 0;
    font-size: 12px;
    text-align: left;
    line-height: 1.4;
  }

  .wrapper-cta {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: auto 180px;
    align-items: center;
  }

  .section-2 {
    .el-button {
      font-size: 14px;
      padding: 10px 15px;
    }
  }
}

.wrapper-section-cta-sidebar {
  box-sizing: border-box;
  border-radius: 10px;
  padding: 20px;
  border: 1px solid rgba(26, 163, 28, 1);
  background: rgba(240, 249, 235, 1);
  display: flex;
  flex-direction: column;
  text-align: center;

  .subtitle-sidebar {
    font-size: 24px;
    font-weight: 700;
    margin-top: 0;
  }

  .section-1,
  .section-3 {
    flex: 1;
    min-height: 20px;
  }

  .section-2 {
    flex: 0;
    max-height: 100%;

    .el-button {
      width: 100%;
      display: block;
      font-size: 16px;

      span {
        line-height: 1.6;
      }

      i {
        margin-right: 10px;
        font-size: 1.2em;
        line-height: 1.6;
      }
    }
  }

  &.affix {
    max-width: 290px;
  }

  @media screen and (max-width: 1026px) {
    @include cta-sidebar-mobile();
  }
}

.el-drawer__wrapper {
  /** `components/navbars/country-cta.vue` */
  .wrapper-section-cta-sidebar {
    @include cta-sidebar-mobile();
  }
}
</style>
